import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import SeoMeta from "@/components/feature/SeoMeta";
import { allVideos, categories } from "@/mocks/videos";

const catName = (id: string) => categories.find((c) => c.id === id)?.name || "吃瓜视频";

export default function RankPage() {
  const sorted = [...allVideos].sort((a, b) => b.heat - a.heat);
  const top3 = sorted.slice(0, 3);
  const rest = sorted.slice(3);

  return (
    <div className="bg-background-50 min-h-screen">
      <SeoMeta
        title="国产吃瓜视频排行榜 - 热门吃瓜视频排行推荐"
        description="国产吃瓜视频热门排行榜，按事件热度实时整理的国产吃瓜视频大全与精选排行。想看重磅吃瓜视频排行、热门推荐一次看全，关注这里了解大家都在看什么。"
        type="collection"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: "国产吃瓜视频排行榜",
            itemListElement: sorted.map((v, i) => ({
              "@type": "ListItem",
              position: i + 1,
              name: v.title,
              url: `https://www.readdy.ai/video/${v.id}`,
            })),
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: "https://www.readdy.ai/" },
              { "@type": "ListItem", position: 2, name: "排行榜" },
            ],
          },
        ]}
      />
      <SiteHeader />

      <section className="bg-primary-950 py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-4 md:px-6 text-center">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold">
            <i className="ri-trophy-line"></i> 实时热度
          </span>
          <h1 className="mt-4 font-heading text-3xl md:text-5xl font-black text-background-50">
            热门吃瓜视频<span className="text-accent-400">排行榜</span>
          </h1>
          <p className="mt-4 max-w-xl mx-auto text-background-50/80">
            按事件热度实时整理的国产吃瓜视频大全与热门精选排行，一次看全大家都在看什么。
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        {/* TOP3 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
          {top3.map((v, i) => (
            <Link
              key={v.id}
              to={`/video/${v.id}`}
              className="group relative rounded-2xl overflow-hidden min-h-[220px] flex items-end"
            >
              <img
                src={v.cover}
                alt={v.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent"></div>
              <span
                className={`absolute top-3 left-3 inline-flex w-10 h-10 items-center justify-center rounded-xl text-xl font-black text-background-50 ${
                  i === 0 ? "bg-primary-500" : i === 1 ? "bg-accent-500" : "bg-secondary-500"
                }`}
              >
                {i + 1}
              </span>
              <div className="relative p-5">
                <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md bg-background-50/15 text-background-50 text-xs">
                  <i className="ri-fire-fill text-accent-400"></i> 热度 {v.heat}
                </span>
                <h2 className="mt-2 text-lg font-black text-background-50 leading-snug line-clamp-2 group-hover:underline">
                  {v.title}
                </h2>
              </div>
            </Link>
          ))}
        </div>

        {/* 榜单列表 */}
        <div className="bg-background-50 border border-background-200 rounded-2xl overflow-hidden">
          {rest.map((v, i) => (
            <Link
              key={v.id}
              to={`/video/${v.id}`}
              className="flex items-center gap-4 p-4 hover:bg-background-100/60 transition-colors border-b border-background-100 last:border-0"
            >
              <span className="w-8 text-center text-lg font-black text-foreground-400">{i + 4}</span>
              <img src={v.cover} alt={v.title} className="w-28 h-16 md:w-32 md:h-20 object-cover rounded-lg" />
              <div className="flex-1 min-w-0">
                <h2 className="text-sm md:text-base font-bold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {v.title}
                </h2>
                <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900">
                    {catName(v.category)}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i> {v.views}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line"></i> {v.duration}
                  </span>
                </div>
              </div>
              <span className="hidden sm:inline-flex items-center gap-1 text-primary-600 text-sm font-bold whitespace-nowrap">
                观看 <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>

      <SiteFooter />
    </div>
  );
}